<template>
    <b-overlay :show="show" @click="$emit('click')" no-wrap fixed opacity="0.70" class="d-block d-md-none">
      <template #overlay>
        <div></div>
      </template>
    </b-overlay>
</template>

<script>
export default {
  name: "Overlay",
    props: {
      show: {
        type: Boolean,
        default: false
      },
      preventScroll: {
        type: Boolean,
        default: false
      }
    },
  watch: {
    show: function (val) {
      if (val && this.preventScroll) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }
}
</script>

<style scoped>

</style>